export default __webpack_public_path__ + "static/certik-score-edbb7a40db691c6fbb828b05e6bae1e4.svg";